import type { DriverEntity } from '@/features/driver/domain/entities/DriverEntity'

export class AssignDriverEntity {
  driver?: DriverEntity
  ignoreVehicleLimitation?: boolean
}
